import * as yup from "yup";

export type Staff = {
  uid: string;
  email: string;
  displayName: string;
  photoUrl?: string;
  pass: string;
  disabled?: boolean;
  emailVerified?: boolean;
};

const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&].*$/;
const characterNumberErrorMessage = '8文字以上⼊⼒してください';
const matchesErrorMessage = "半角 英・数・記号(@$!%*#?&)1文字ずつを含む8文字以上で登録ください";
export const staffSchema = yup.object({
  updateFlg: yup.boolean().required(),
  email: yup.string().email().required(),
  displayName: yup.string().required(),
  pass: yup.string().when('updateFlg', {
    is: false,
    then: yup.string()
      .required()
      .min(8, characterNumberErrorMessage)
      .matches(
        regex,
        matchesErrorMessage
      ),
  }).when('updateFlg', {
    is: true,
    then: yup.string()
      .min(8, characterNumberErrorMessage)
      .matches(
        regex,
        matchesErrorMessage
      ),
  })
});
